import React, { useEffect, useState } from "react";
import { Image, Maximize2 } from "react-feather";
import { useGetFuelTransactionImageQuery } from "../fuelApi";

// One evidence photo (kind: "odometer" | "pump"), shown LARGE - checking the
// reading against the photo is the whole point of the review screen. Photos
// are authenticated, so each is fetched as a Blob and shown through an object
// URL that is released when the photo goes away (same discipline as
// AlarmPhotoGallery). Clicking hands the blob up for the full-size lightbox.
const FuelEvidencePhoto = ({ recordGuid, kind, label, caption, available, onOpen }) => {
  const { data: blob, isError, isFetching } = useGetFuelTransactionImageQuery({ recordGuid, kind }, { skip: !available });
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!blob) return undefined;
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => {
      URL.revokeObjectURL(objectUrl);
      setUrl(null);
    };
  }, [blob]);

  return (
    <div style={{ width: "48%", minWidth: 260 }}>
      <div className="d-flex justify-content-between align-items-baseline mb-1">
        <span className="fw-semibold">{label}</span>
        {caption && <span className="small text-muted">{caption}</span>}
      </div>
      <button
        type="button"
        className="btn p-0 border rounded overflow-hidden position-relative w-100 d-block"
        style={{ background: "#F1F3F5", minHeight: 300 }}
        disabled={!url}
        onClick={() => onOpen(blob, kind, label)}
        title="Open full size"
      >
        {url ? (
          <>
            <img src={url} alt={label} style={{ width: "100%", maxHeight: 460, objectFit: "contain", display: "block" }} />
            <span className="position-absolute top-0 end-0 m-2 rounded px-1 text-white" style={{ background: "rgba(0,0,0,.55)" }}>
              <Maximize2 size={14} />
            </span>
          </>
        ) : (
          <span className="d-flex flex-column align-items-center justify-content-center text-muted small" style={{ minHeight: 300 }}>
            <Image size={24} className="mb-1" />
            {!available ? "No photo on record" : isError ? "Could not load the photo" : isFetching ? "Loading…" : ""}
          </span>
        )}
      </button>
    </div>
  );
};

export default FuelEvidencePhoto;
